import { IRangeCount, IRangeCountByQuestion, IStats, Range } from '@root/types';
import Answers from '@root/db/entity/Answers';

const getBarChartData = (allAnswers: Answers[]): IStats => {
  const overAllScoreRanges = countRanges(allAnswers);
  const questionScoreRanges = countQuestionRanges(allAnswers);

  return { overAllScoreRanges, questionScoreRanges };
};

export const countRanges = (ranges: { range: Range }[]): IRangeCount[] => {
  const rangeCount: IRangeCount[] = [
    { range: '0-19', count: 0 },
    { range: '20-39', count: 0 },
    { range: '40-59', count: 0 },
    { range: '60-79', count: 0 },
    { range: '80-100', count: 0 },
  ];

  ranges.forEach((value: { range: string }) => {
    const foundRange = rangeCount.find((rangeObj) => {
      return rangeObj.range === value.range;
    });
    if (foundRange) {
      foundRange.count += 1;
    }
  });

  return rangeCount;
};

export const countQuestionRanges = (
  allAnswers: Answers[],
): IRangeCountByQuestion[] => {
  const questionIds = allAnswers[0].answers.map(
    (question) => question.questionId,
  );
  const allRanges = allAnswers.flatMap((question) => {
    return question.answers.map((answer) => {
      return {
        questionId: answer.questionId,
        range: answer.range,
      };
    });
  });

  const rangesByQuestion = questionIds.map((questionId) => {
    return {
      questionId,
      ranges: allRanges.filter((obj) => obj.questionId === questionId),
    };
  });

  const result = rangesByQuestion.map((question) => {
    return {
      questionId: question.questionId,
      rangeCount: countRanges(question.ranges),
    };
  });

  return result;
};

export default getBarChartData;
